// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"329":"bdb52925","453":"755619bf"}[chunkId] + ".chunk.js";
};